import { n_tutors, s_tutors } from '../../../../modules/i18n/strings/auto/wording'
import useTranslation from '../../../../modules/i18n/useTranslation'
import Graph from './Graph'
import ReviewItem from './ReviewItem'

const ReviewsPanel = ({ data }: { data: any }) => {
  const { t } = useTranslation()
  return (
    <div className="px-[16px]">
      {data.main_evaluation_keywords?.length > 0 && (
        <div>
          <div>
            {data.main_evaluation_keywords?.map((item, i) => (
              <Graph key={i} proportion={item.proportion} keyword={item.keyword} />
            ))}
          </div>
          <div className="Body2-14Md mt-16 text-gray-500">{t(n_tutors.review_explanation)}</div>
        </div>
      )}
      <div className="mt-[16px] h-[1px] w-full bg-gray-200"></div>
      <div className="divide-y-1 mt-[16px] flex flex-col divide-gray-200">
        {data.reviews?.length > 0 ? (
          data?.reviews.map((item, i) => <ReviewItem key={`item-${i}`} item={item} i={i} />)
        ) : (
          <div className="mt-[50px] text-center">{t(s_tutors.no_review_yet)}</div>
        )}
      </div>
    </div>
  )
}
export default ReviewsPanel
